<article class="progress-reports-container">
  <div class="progress-reports-sub">
    <app-progress-reports-side-menu
      class="side-menu"
    ></app-progress-reports-side-menu>

    <div class="sub"><router-outlet></router-outlet></div>
  </div>
</article>
